<template>
  <div class="search-tag-btns">
    <button type="button" @click="tagSelect('vod')" class="search-tag-btn tag-btn-series">시리즈</button>
    <button type="button" @click="tagSelect('movie')" class="search-tag-btn tag-btn-movie">영화</button>
  </div>
</template>
<script>
import { PATH_NAME_SEARCH_TAG } from '@/common/router.const'
import { mapMutations } from 'vuex'
import { sendEventLogShowTagSearchPopup } from '@/common/util/log.v2.send'

export default {
  name: 'SearchTagBox',
  methods: {
    ...mapMutations(['deleteAllTag', 'setTagTabType']),
    tagSelect (tabType) {
      this.deleteAllTag()
      this.setTagTabType(tabType)
      sendEventLogShowTagSearchPopup({ type: tabType })
      this.$router.push({
        name: PATH_NAME_SEARCH_TAG
      })
    }
  }
}
</script>
